import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Guid } from "@/Common/Models/Guid";
import { PrescriptionRenewalsOrderType, SortDirection } from "@/Common/Models/UI/Enums";

export class PrescriptionRenewalInboxSettings {
    public responsibleProviderContactId: Guid = GuidHelper.Empty();
    public searchText: string = "";
    public queryOrderType: PrescriptionRenewalsOrderType = PrescriptionRenewalsOrderType.ReceivedDate;
    public queryOrderDirection: SortDirection = SortDirection.DESC;
    public currentPageNumber: number;
    public pageSize: number = 50;

    constructor(currentPageNumber: number = 1) {
        this.currentPageNumber = currentPageNumber;
    }
}
